// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.fc-ai-import-dialog {
  width: 100%;
  max-width: 520px;
  padding: 0;
  display: flex;
  flex-direction: column;
  max-height: min(90vh, 720px);
  box-sizing: border-box;
  text-align: left;
}

.fc-ai-import-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e4e8f0;
  text-align: left;
}
.fc-ai-import-header .title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}
.fc-ai-import-header span {
  font-size: 13px;
  color: #6b7280;
}

.icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #eef6fc;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.icon-circle mat-icon {
  color: #5ea1d8;
}

.header-left {
  display: flex;
  align-items: center;
  text-align: left;
}

.icon-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
}

.fc-ai-import-body {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  text-align: left;
}

.field-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #374151;
}

.field-hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: #6b7280;
}

.source-mode-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.source-mode-tab {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  color: #4b5563;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.source-mode-tab mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.source-mode-tab.active {
  border-color: #5ea1d8;
  background: #eef6fc;
  color: #1d4ed8;
}

.upload-picker {
  position: relative;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  background: #f9fafb;
  min-height: 88px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  margin-bottom: 4px;
  text-align: left;
  overflow: visible;
}
.upload-picker input[type=file] {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.upload-picker-copy,
.upload-picker-selected {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #4b5563;
  pointer-events: none;
  width: 100%;
  min-width: 0;
  text-align: left;
}
.upload-picker-copy mat-icon,
.upload-picker-selected mat-icon {
  color: #5ea1d8;
  flex-shrink: 0;
  overflow: visible;
  width: 24px;
  height: 24px;
  font-size: 24px;
  line-height: 24px;
}
.upload-picker-copy span,
.upload-picker-selected span {
  flex: 1;
  min-width: 0;
}

.upload-picker-selected {
  width: 100%;
  justify-content: space-between;
}
.upload-picker-selected span {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clear-file-btn {
  pointer-events: auto;
  border: none;
  background: #e5e7eb;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.clear-file-btn mat-icon {
  flex-shrink: 0;
  overflow: visible;
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: #374151;
}

.panel-toggle-header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}
.panel-toggle-header mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #5ea1d8;
}
.panel-toggle-header .panel-toggle-title {
  flex: 1;
  min-width: 0;
}
.panel-toggle-header .panel-toggle-chevron {
  color: #6b7280;
}

.requirements-panel {
  margin-top: 16px;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
}
.requirements-panel.collapsed {
  padding: 10px 12px;
}

.requirements-title {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.requirements-list {
  margin: 0;
  padding-left: 18px;
  font-size: 12px;
  color: #4b5563;
  line-height: 1.45;
}
.requirements-list li + li {
  margin-top: 6px;
}

.url-input {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 14px;
}

.notes-input {
  resize: vertical;
  min-height: 72px;
  margin-bottom: 4px;
}

.document-picker {
  margin-bottom: 4px;
}

.policy-panel {
  margin-top: 16px;
  padding: 12px 14px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #f0f7ff;
}
.policy-panel.collapsed {
  padding: 10px 12px;
}
.policy-panel .panel-toggle-header mat-icon {
  color: #1d4ed8;
}

.policy-title {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 600;
  color: #1d4ed8;
}

.policy-list {
  margin: 0;
  padding-left: 18px;
  font-size: 12px;
  color: #374151;
  line-height: 1.45;
}
.policy-list li + li {
  margin-top: 6px;
}

.policy-links {
  margin: 10px 0 0;
  font-size: 12px;
  color: #4b5563;
}
.policy-links a {
  color: #2563eb;
  font-weight: 600;
  text-decoration: underline;
}

.consent-section {
  margin-top: 4px;
}
.consent-section.consent-highlight {
  margin-top: 14px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #f59e0b;
  background: #fffbeb;
  animation: consent-pulse 1.2s ease-in-out 2;
}

@keyframes consent-pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.2);
  }
}
.consent-check {
  display: flex;
  gap: 10px;
  margin-top: 14px;
  font-size: 13px;
  color: #4b5563;
  cursor: pointer;
}
.consent-check input {
  margin-top: 3px;
  flex-shrink: 0;
}
.consent-check a {
  color: #2563eb;
  font-weight: 600;
  text-decoration: underline;
}

.document-support-check {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.error {
  color: #b91c1c;
  font-size: 13px;
  margin-top: 12px;
}

.fc-ai-import-actions {
  display: flex !important;
  visibility: visible !important;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 24px 20px;
  border-top: 1px solid #e4e8f0;
  flex-shrink: 0;
  background: #fff;
  text-align: right;
}
@media (max-width: 480px) {
  .fc-ai-import-actions {
    flex-direction: column-reverse;
  }
  .fc-ai-import-actions .btn-primary,
  .fc-ai-import-actions .btn-secondary {
    width: 100%;
  }
}

.btn-primary,
.btn-secondary {
  border: none;
  border-radius: 10px;
  padding: 10px 18px;
  font-weight: 600;
  cursor: pointer;
}

.btn-primary {
  background: #5ea1d8;
  color: #fff;
}

.btn-secondary {
  background: #f3f4f6;
  color: #374151;
}

:host-context(body.theme-dark) .fc-ai-import-dialog {
  background: #0f172a;
  color: #f3f4f6;
}
:host-context(body.theme-dark) .fc-ai-import-header {
  background: #111827;
  border-bottom-color: rgba(148, 163, 184, 0.28);
}
:host-context(body.theme-dark) .fc-ai-import-header .title {
  color: #f3f4f6;
}
:host-context(body.theme-dark) .fc-ai-import-header span {
  color: #94a3b8;
}
:host-context(body.theme-dark) .icon-circle {
  background: #1e293b;
}
:host-context(body.theme-dark) .icon-circle mat-icon {
  color: #7ab8e8;
}
:host-context(body.theme-dark) .icon-button {
  color: #94a3b8;
}
:host-context(body.theme-dark) .icon-button:hover {
  color: #f3f4f6;
}
:host-context(body.theme-dark) .fc-ai-import-body {
  background: #0f172a;
}
:host-context(body.theme-dark) .field-label {
  color: #e5e7eb;
}
:host-context(body.theme-dark) .field-hint {
  color: #94a3b8;
}
:host-context(body.theme-dark) .url-input,
:host-context(body.theme-dark) .notes-input {
  background: #111827;
  border-color: rgba(148, 163, 184, 0.35);
  color: #f9fafb;
}
:host-context(body.theme-dark) .url-input::placeholder,
:host-context(body.theme-dark) .notes-input::placeholder {
  color: #64748b;
}
:host-context(body.theme-dark) .upload-picker {
  border-color: rgba(148, 163, 184, 0.35);
  background: #111827;
}
:host-context(body.theme-dark) .upload-picker-copy,
:host-context(body.theme-dark) .upload-picker-selected {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .upload-picker-copy mat-icon,
:host-context(body.theme-dark) .upload-picker-selected mat-icon {
  color: #7ab8e8;
}
:host-context(body.theme-dark) .upload-picker-selected {
  background: #1e293b;
}
:host-context(body.theme-dark) .clear-file-btn {
  color: #94a3b8;
}
:host-context(body.theme-dark) .requirements-panel,
:host-context(body.theme-dark) .policy-panel {
  background: #111827;
  border-color: rgba(148, 163, 184, 0.28);
}
:host-context(body.theme-dark) .requirements-title,
:host-context(body.theme-dark) .policy-title,
:host-context(body.theme-dark) .panel-toggle-title {
  color: #e5e7eb;
}
:host-context(body.theme-dark) .requirements-list,
:host-context(body.theme-dark) .policy-list {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .policy-links {
  color: #94a3b8;
}
:host-context(body.theme-dark) .policy-links a {
  color: #93c5fd;
}
:host-context(body.theme-dark) .consent-check {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .consent-check a {
  color: #93c5fd;
}
:host-context(body.theme-dark) .consent-section.consent-highlight {
  background: rgba(120, 53, 15, 0.35);
  border-color: rgba(245, 158, 11, 0.55);
}
:host-context(body.theme-dark) .document-support-check {
  background: #1e293b;
  border-color: rgba(148, 163, 184, 0.28);
}
:host-context(body.theme-dark) .fc-ai-import-actions {
  background: #111827;
  border-top-color: rgba(148, 163, 184, 0.28);
}
:host-context(body.theme-dark) .btn-secondary {
  background: #1e293b;
  color: #f3f4f6;
  border: 1px solid rgba(148, 163, 184, 0.35);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/flowchest-ai-import-dialog/flowchest-ai-import-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;AACF;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,eAAA;EACA,cAAA;AAAJ;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AADF;AAGE;EACE,cAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAFF;;AAKA;EACE,OAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAFF;AAIE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAFJ;AAKE;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAJF;AAME;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAJJ;;AAQA;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AALF;AAOE;;EACE,cAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAJJ;AAOE;;EACE,OAAA;EACA,YAAA;AAJJ;;AAQA;EACE,WAAA;EACA,8BAAA;AALF;AAOE;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AALJ;;AASA;EACE,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AANF;AAQE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AANJ;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAPF;AASE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAPJ;AAUE;EACE,OAAA;EACA,YAAA;AARJ;AAWE;EACE,cAAA;AATJ;;AAaA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAVF;AAYE;EACE,kBAAA;AAVJ;;AAcA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAXF;;AAcA;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAXF;AAaE;EACE,eAAA;AAXJ;;AAeA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AAZF;;AAeA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAZF;;AAeA;EACE,kBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAZF;AAcE;EACE,kBAAA;AAZJ;AAeE;EACE,cAAA;AAbJ;;AAiBA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAdF;AAgBE;EACE,eAAA;AAdJ;;AAkBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAfF;AAiBE;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;AAfJ;;AAmBA;EACE,eAAA;AAhBF;AAkBE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;AAhBJ;;AAoBA;EACE;IAEE,yCAAA;EAlBF;EAoBA;IACE,6CAAA;EAlBF;AACF;AAqBA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAnBF;AAqBE;EACE,eAAA;EACA,cAAA;AAnBJ;AAsBE;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;AApBJ;;AAwBA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AArBF;;AAwBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,wBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AArBF;AAuBE;EAZF;IAaI,8BAAA;EApBF;EAsBE;;IAEE,WAAA;EApBJ;AACF;;AAwBA;;EAEE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AArBF;;AAwBA;EACE,mBAAA;EACA,WAAA;AArBF;;AAwBA;EACE,mBAAA;EACA,cAAA;AArBF;;AAyBE;EACE,mBAAA;EACA,cAAA;AAtBJ;AAyBE;EACE,mBAAA;EACA,8CAAA;AAvBJ;AAyBI;EACE,cAAA;AAvBN;AA0BI;EACE,cAAA;AAxBN;AA4BE;EACE,mBAAA;AA1BJ;AA4BI;EACE,cAAA;AA1BN;AA8BE;EACE,cAAA;AA5BJ;AA8BI;EACE,cAAA;AA5BN;AAgCE;EACE,mBAAA;AA9BJ;AAiCE;EACE,cAAA;AA/BJ;AAkCE;EACE,cAAA;AAhCJ;AAmCE;;EAEE,mBAAA;EACA,uCAAA;EACA,cAAA;AAjCJ;AAmCI;;EACE,cAAA;AAhCN;AAoCE;EACE,uCAAA;EACA,mBAAA;AAlCJ;AAqCE;;EAEE,cAAA;AAnCJ;AAqCI;;EACE,cAAA;AAlCN;AAsCE;EACE,mBAAA;AApCJ;AAuCE;EACE,cAAA;AArCJ;AAwCE;;EAEE,mBAAA;EACA,uCAAA;AAtCJ;AAyCE;;;EAGE,cAAA;AAvCJ;AA0CE;;EAEE,cAAA;AAxCJ;AA2CE;EACE,cAAA;AAzCJ;AA2CI;EACE,cAAA;AAzCN;AA6CE;EACE,cAAA;AA3CJ;AA6CI;EACE,cAAA;AA3CN;AA+CE;EACE,mCAAA;EACA,sCAAA;AA7CJ;AAgDE;EACE,mBAAA;EACA,uCAAA;AA9CJ;AAiDE;EACE,mBAAA;EACA,2CAAA;AA/CJ;AAkDE;EACE,mBAAA;EACA,cAAA;EACA,2CAAA;AAhDJ","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n}\n\n.fc-ai-import-dialog {\n  width: 100%;\n  max-width: 520px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  max-height: min(90vh, 720px);\n  box-sizing: border-box;\n  text-align: left;\n}\n\n.fc-ai-import-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e4e8f0;\n  text-align: left;\n\n  .title {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n  }\n\n  span {\n    font-size: 13px;\n    color: #6b7280;\n  }\n}\n\n.icon-circle {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #eef6fc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n\n  mat-icon {\n    color: #5ea1d8;\n  }\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  text-align: left;\n}\n\n.icon-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n}\n\n.fc-ai-import-body {\n  padding: 20px 24px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n  text-align: left;\n}\n\n.field-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #374151;\n}\n\n.field-hint {\n  margin: 8px 0 0;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.source-mode-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.source-mode-tab {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #fff;\n  color: #4b5563;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &.active {\n    border-color: #5ea1d8;\n    background: #eef6fc;\n    color: #1d4ed8;\n  }\n}\n\n.upload-picker {\n  position: relative;\n  border: 1px dashed #cbd5e1;\n  border-radius: 10px;\n  background: #f9fafb;\n  min-height: 88px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 12px;\n  margin-bottom: 4px;\n  text-align: left;\n  overflow: visible;\n\n  input[type=\"file\"] {\n    position: absolute;\n    inset: 0;\n    opacity: 0;\n    cursor: pointer;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.upload-picker-copy,\n.upload-picker-selected {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #4b5563;\n  pointer-events: none;\n  width: 100%;\n  min-width: 0;\n  text-align: left;\n\n  mat-icon {\n    color: #5ea1d8;\n    flex-shrink: 0;\n    overflow: visible;\n    width: 24px;\n    height: 24px;\n    font-size: 24px;\n    line-height: 24px;\n  }\n\n  span {\n    flex: 1;\n    min-width: 0;\n  }\n}\n\n.upload-picker-selected {\n  width: 100%;\n  justify-content: space-between;\n\n  span {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.clear-file-btn {\n  pointer-events: auto;\n  border: none;\n  background: #e5e7eb;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  mat-icon {\n    flex-shrink: 0;\n    overflow: visible;\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    color: #374151;\n  }\n}\n\n.panel-toggle-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    flex-shrink: 0;\n    color: #5ea1d8;\n  }\n\n  .panel-toggle-title {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .panel-toggle-chevron {\n    color: #6b7280;\n  }\n}\n\n.requirements-panel {\n  margin-top: 16px;\n  padding: 12px 14px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #f9fafb;\n\n  &.collapsed {\n    padding: 10px 12px;\n  }\n}\n\n.requirements-title {\n  margin: 0 0 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.requirements-list {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 12px;\n  color: #4b5563;\n  line-height: 1.45;\n\n  li + li {\n    margin-top: 6px;\n  }\n}\n\n.url-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 14px;\n}\n\n.notes-input {\n  resize: vertical;\n  min-height: 72px;\n  margin-bottom: 4px;\n}\n\n.document-picker {\n  margin-bottom: 4px;\n}\n\n.policy-panel {\n  margin-top: 16px;\n  padding: 12px 14px;\n  border: 1px solid #dbeafe;\n  border-radius: 10px;\n  background: #f0f7ff;\n\n  &.collapsed {\n    padding: 10px 12px;\n  }\n\n  .panel-toggle-header mat-icon {\n    color: #1d4ed8;\n  }\n}\n\n.policy-title {\n  margin: 0 0 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1d4ed8;\n}\n\n.policy-list {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 12px;\n  color: #374151;\n  line-height: 1.45;\n\n  li + li {\n    margin-top: 6px;\n  }\n}\n\n.policy-links {\n  margin: 10px 0 0;\n  font-size: 12px;\n  color: #4b5563;\n\n  a {\n    color: #2563eb;\n    font-weight: 600;\n    text-decoration: underline;\n  }\n}\n\n.consent-section {\n  margin-top: 4px;\n\n  &.consent-highlight {\n    margin-top: 14px;\n    padding: 12px;\n    border-radius: 10px;\n    border: 1px solid #f59e0b;\n    background: #fffbeb;\n    animation: consent-pulse 1.2s ease-in-out 2;\n  }\n}\n\n@keyframes consent-pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0);\n  }\n  50% {\n    box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.2);\n  }\n}\n\n.consent-check {\n  display: flex;\n  gap: 10px;\n  margin-top: 14px;\n  font-size: 13px;\n  color: #4b5563;\n  cursor: pointer;\n\n  input {\n    margin-top: 3px;\n    flex-shrink: 0;\n  }\n\n  a {\n    color: #2563eb;\n    font-weight: 600;\n    text-decoration: underline;\n  }\n}\n\n.document-support-check {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n}\n\n.error {\n  color: #b91c1c;\n  font-size: 13px;\n  margin-top: 12px;\n}\n\n.fc-ai-import-actions {\n  display: flex !important;\n  visibility: visible !important;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 16px 24px 20px;\n  border-top: 1px solid #e4e8f0;\n  flex-shrink: 0;\n  background: #fff;\n  text-align: right;\n\n  @media (max-width: 480px) {\n    flex-direction: column-reverse;\n\n    .btn-primary,\n    .btn-secondary {\n      width: 100%;\n    }\n  }\n}\n\n.btn-primary,\n.btn-secondary {\n  border: none;\n  border-radius: 10px;\n  padding: 10px 18px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn-primary {\n  background: #5ea1d8;\n  color: #fff;\n}\n\n.btn-secondary {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n:host-context(body.theme-dark) {\n  .fc-ai-import-dialog {\n    background: #0f172a;\n    color: #f3f4f6;\n  }\n\n  .fc-ai-import-header {\n    background: #111827;\n    border-bottom-color: rgba(148, 163, 184, 0.28);\n\n    .title {\n      color: #f3f4f6;\n    }\n\n    span {\n      color: #94a3b8;\n    }\n  }\n\n  .icon-circle {\n    background: #1e293b;\n\n    mat-icon {\n      color: #7ab8e8;\n    }\n  }\n\n  .icon-button {\n    color: #94a3b8;\n\n    &:hover {\n      color: #f3f4f6;\n    }\n  }\n\n  .fc-ai-import-body {\n    background: #0f172a;\n  }\n\n  .field-label {\n    color: #e5e7eb;\n  }\n\n  .field-hint {\n    color: #94a3b8;\n  }\n\n  .url-input,\n  .notes-input {\n    background: #111827;\n    border-color: rgba(148, 163, 184, 0.35);\n    color: #f9fafb;\n\n    &::placeholder {\n      color: #64748b;\n    }\n  }\n\n  .upload-picker {\n    border-color: rgba(148, 163, 184, 0.35);\n    background: #111827;\n  }\n\n  .upload-picker-copy,\n  .upload-picker-selected {\n    color: #cbd5e1;\n\n    mat-icon {\n      color: #7ab8e8;\n    }\n  }\n\n  .upload-picker-selected {\n    background: #1e293b;\n  }\n\n  .clear-file-btn {\n    color: #94a3b8;\n  }\n\n  .requirements-panel,\n  .policy-panel {\n    background: #111827;\n    border-color: rgba(148, 163, 184, 0.28);\n  }\n\n  .requirements-title,\n  .policy-title,\n  .panel-toggle-title {\n    color: #e5e7eb;\n  }\n\n  .requirements-list,\n  .policy-list {\n    color: #cbd5e1;\n  }\n\n  .policy-links {\n    color: #94a3b8;\n\n    a {\n      color: #93c5fd;\n    }\n  }\n\n  .consent-check {\n    color: #cbd5e1;\n\n    a {\n      color: #93c5fd;\n    }\n  }\n\n  .consent-section.consent-highlight {\n    background: rgba(120, 53, 15, 0.35);\n    border-color: rgba(245, 158, 11, 0.55);\n  }\n\n  .document-support-check {\n    background: #1e293b;\n    border-color: rgba(148, 163, 184, 0.28);\n  }\n\n  .fc-ai-import-actions {\n    background: #111827;\n    border-top-color: rgba(148, 163, 184, 0.28);\n  }\n\n  .btn-secondary {\n    background: #1e293b;\n    color: #f3f4f6;\n    border: 1px solid rgba(148, 163, 184, 0.35);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
